export enum UserType {
  ADMIN = 'admin',
  EXPERT = 'expert',
  RESEARCHER = 'researcher',
}
